var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dropdown-with-toggles input input--select" },
    [
      _c(
        "div",
        {
          staticClass: "dropdown-with-toggles__label",
          on: { click: _vm.toggleDropdown }
        },
        [
          _c("div", {
            staticClass: "dropdown-with-toggles__label-inner",
            domProps: { textContent: _vm._s(_vm.labelText) }
          }),
          _c(
            "div",
            {
              staticClass: "dropdown-with-toggles__label-icon",
              class: { open: _vm.toggleOpen }
            },
            [_c("icon", { attrs: { name: "chevron-down", size: "22px" } })],
            1
          )
        ]
      ),
      _vm.toggleOpen
        ? _c(
            "div",
            { staticClass: "dropdown-with-toggles__inner" },
            [
              _c("checkbox-toggle-all", {
                attrs: {
                  label: "All Stores",
                  checked: _vm.toggleAllState,
                  allOptions: _vm.dropdownOptions
                },
                on: { input: _vm.toggleAllValues }
              }),
              _vm._l(_vm.dropdownOptions, function(value, key) {
                return _c("checkbox-input", {
                  key: key,
                  attrs: { label: key, value: key, checked: value },
                  on: {
                    input: function($event) {
                      return _vm.updateCheckboxValue(key)
                    }
                  }
                })
              })
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "dropdown-with-toggles__toggle" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }